export const RespondentsOverviewModel = {
  reportPeriodGid: "reportPeriodGid",
  surveyId: "surveyId",
  version: "version",
  title: "title",
  projectForeignId: "projectForeignId",
  universityName: "universityName",
  projectCategory: "projectCategory",
  fundingArea: "fundingArea",
  program: "program",
  programInstance: "programInstance",
  project: "project",
  start: "start",
  end: "end",
  status: "status",
  lastEdit: "lastEdit",
  editedBy: "editedBy",
  lecturer: "lecturer",
  lastSubmittedBy: "lastSubmittedBy",
  lastSubmitted: "lastSubmitted"
};

export const RespondentDetailsModel = {
  id: "id",
  surveyId: "surveyId",
  pageName: "pageName",
  pageTitle: "pageTitle",
  progress: "progress",
  respondent: "respondent",
  status: "status",
  lastEdit: "lastEdit",
  editBy: "editBy"
};

export const SurveyModel = {
  identifier: "identifier",
  surveyName: "surveyName",
  description: "description",
  version: "version",
  createdDate: "createdDate",
  lastModifiedDate: "lastModifiedDate",
  updatedBy: "updatedBy",
  fundingArea: "fundingArea",
  program: "program",
  programInstance: "programInstance",
  project: "project",
  language: "language",
  surveyTemplate: "surveyTemplate",
  $surveyTemplate: {
    version: "version",
    surveyId: "surveyId",
    title: "title",
    pages: "pages",
    updated: "updated",
    updatedBy: "updatedBy"
  }
};

export const FilesModel = {
  files: "files",
  rowName: "rowName",
  columnName: "columnName"
};
